import { connect } from 'react-redux';

import ThankYouPage from './component';

const mapStateToProps = (state) => {
	const { raffleForm: { registration, raffle }, ui } = state;

	return {
		registrationId: registration ? registration.id : null,
		raffleClosedAt: raffle ? raffle.closeRegistrationAt : null,
		suggestedShopId: ui.suggestedShopId
	};
};

const ThankYouPageContainer = connect(mapStateToProps)(ThankYouPage);

export default ThankYouPageContainer;



// WEBPACK FOOTER //
// ./routes/thankYou/container.js